module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LS032B7DD02-6-19-17.231df8ef.pdf";